"use strict";
/* eslint-disable complexity */
/* eslint-disable no-console */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbUSDAuthenticator = void 0;
const framework_1 = require("../../../framework");
const types_1 = require("../../../features/session/cc/types");
const helper_1 = require("../cc/helper");
//TODO Authenticator only for model or not??
class MbUSDAuthenticator extends framework_1.BaseAuthenticator {
    constructor(session, xhr, modelbankUSDManager, urlConfig) {
        super(session);
        this.doLogout = () => __awaiter(this, void 0, void 0, function* () {
            const sessionData = this.getSession().getData();
            const accessToken = sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken;
            const headers = {
                accessToken: sessionData === null || sessionData === void 0 ? void 0 : sessionData.agentToken,
            };
            yield this.xhr.POST(this.urlConfig.logout, { accessToken }, headers);
        });
        this.doLogin = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield this.modelbankUSDManager.init();
            if (data) {
                return {
                    accessToken: data.securitySSR_AccessToken,
                    refreshToken: data.securitySSR_RefreshToken,
                    agentToken: data.agentToken,
                    username: data.userName,
                    expiresIn: 5000,
                    sessionExpiresAt: (0, helper_1.createSessionExpiresAt)(),
                    entrypoint: types_1.EntrypointType.USD,
                };
            }
            return null;
        });
        this.xhr = xhr;
        this.modelbankUSDManager = modelbankUSDManager;
        this.urlConfig = urlConfig;
    }
}
exports.MbUSDAuthenticator = MbUSDAuthenticator;
//# sourceMappingURL=index.js.map